<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('edita-vinculo-insumo') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="
                        assNvTecnologicoProduto.consumoalqueire < 0 ||
                        assNvTecnologicoProduto.consumohectare < 0
                    "
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>
        <br />
        <div class="columns">
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="alqueireInput"
                    title="consumoalqueire"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    v-model="assNvTecnologicoProduto.consumoalqueire"
                    :invalid="isNull(assNvTecnologicoProduto.consumoalqueire)"
                    :max="9999999"
                    tooltipLabel="informacao-alqueire"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="hectareInput"
                    title="consumohectare"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    v-model="assNvTecnologicoProduto.consumohectare"
                    :invalid="isNull(assNvTecnologicoProduto.consumohectare)"
                    :max="9999999"
                    tooltipLabel="informacao-hectare"
                    tooltipPosition="is-left"
                />
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import AgroAssNivelTecnologicoProdutoService from '@/services/agro/nivel-tecnologico/AgroAssNivelTecnologicoProdutoService';

// MENSAGENS
import Message from '@/models/Message';

/* @71224 - Cadastro de nível tecnológico - Aba insumos */
export default {
    props: {
        assToEditId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            service: new AgroAssNivelTecnologicoProdutoService(this.$http, this.$router),
            title: '',
            isLoading: false,

            assNvTecnologicoProduto: {
                idagroniveltecnologico: null,
                consumoalqueire: 0,
                consumohectare: 0,
                idproduto: null,
            },
            msgs: [],
            consumoalqueire: 0,
            consumohectare: 0,
        };
    },
    created() {
        this.assNvTecnologicoProduto.idagro_assniveltecnologicoproduto = this.assToEditId;
        if (this.assNvTecnologicoProduto.idagro_assniveltecnologicoproduto > 0) {
            this.carregarDados(this.assNvTecnologicoProduto.idagro_assniveltecnologicoproduto);
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;

            this.service
                .find(id)
                .then((value) => {
                    this.assNvTecnologicoProduto = value.content;
                    this.title = this.assNvTecnologicoProduto.produto.descricao;
                })
                .catch((e) => {
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            if (
                this.assNvTecnologicoProduto.consumoalqueire >= 0 &&
                this.assNvTecnologicoProduto.consumohectare >= 0
            ) {
                this.isLoading = true;
                this.service
                    .saveSingle(this.assNvTecnologicoProduto)
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message('error', `${value.message}`, true));
                        } else {
                            this.$emit('fecharModal', true);
                            this.$root.showMessage('success', 'msg-sucesso-ao-editar-associcao');
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('error', 'msg-selecione-produto', true));
                this.isLoading = false;
            }
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
        generateId(numberId) {
            return this.$route.name + '-insumo-edit-' + numberId;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
}
</style>
